import { render, staticRenderFns } from "./lactationDaysWiseSearch.vue?vue&type=template&id=37b721a9&scoped=true&"
import script from "./lactationDaysWiseSearch.vue?vue&type=script&lang=js&"
export * from "./lactationDaysWiseSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b721a9",
  null
  
)

export default component.exports